import styled from '@emotion/styled';
import classNames from 'classnames';
import { FC } from 'react';

import Text, { TextProps } from '.';
import { FontColor } from '../../theme';

// Local Typings
interface StyledTextProps {
  focusBorderColor?: FontColor;
}
export interface LinkProps extends TextProps, StyledTextProps {
  ariaHasPopUp?: boolean;
  ariaLabel?: string;
  disabled?: boolean;
  href?: string;
  onClick?: () => void;
  target?: string;
}

// Local Variables
const StyledText = styled(Text)<StyledTextProps>(({ theme }) => ({
  display: 'inline-block',
  fontWeight: 'normal',
  outlineOffset: 2,
  textDecorationLine: 'underline',
  transition: '300ms',

  /* eslint-disable sort-keys,@typescript-eslint/naming-convention */
  '&:active': {
    color: theme.semanticColors.text_link,
  },
  /* eslint-enable sort-keys,@typescript-eslint/naming-convention */
}));

// Component Definition
const Link: FC<LinkProps> = ({
  ariaHasPopUp,
  ariaLabel,
  disabled,
  ...props
}) => {
  function handleClick(e: React.MouseEvent) {
    e.stopPropagation();
    e.preventDefault();
    if (!disabled) {
      props.onClick?.();
    }
  }

  function handleKeyDown(e: React.KeyboardEvent) {
    if (e.key === 'Enter' || e.key === ' ') {
      e.stopPropagation();
      e.preventDefault();
      props.onClick?.();
    }
  }

  return (
    <StyledText
      aria-haspopup={ariaHasPopUp}
      aria-label={ariaLabel}
      as="a"
      cursor={disabled ? 'not-allowed' : 'pointer'}
      disabled={disabled}
      fontColor={disabled ? 'text_disabled' : 'text_link'}
      {...props}
      className={classNames(props.className, 'text_link')}
      onClick={props.href ? undefined : handleClick}
      onKeyDown={props.href ? undefined : handleKeyDown}
      tabIndex={disabled ? undefined : 0}
      width="fit-content"
    >
      {props.children}
    </StyledText>
  );
};

export default Link;
